import "./Card/CardComponent";
import "./Dropdown/dropdown-component";
import "./Modal/js/modal-component";
import "./Modal/js/modal-home-component";
import "./Slider/slider-component";
import "./Tabs/tabs-component";



// WEBPACK FOOTER //
// ./web/app/themes/wwp_child_theme/includes/Components/components.js